import ASWScoreboardSVG from "@/components/standings/ASWScoreboardSVG";
import MFGScoreboardSVG from "@/components/standings/MFGScoreboardSVG";
import NSDScoreboardSVG from "@/components/standings/NSDScoreboardSVG";
import VHVScoreboardSVG from "@/components/standings/VHVScoreboardSVG";
import { CLAN_STANDINGS_CURRENT_SEASON } from "@/graphql/queries/leaderboardQueries";
import { useQuery } from "@apollo/client";

interface ClanLeaderboard {
    clanName: string;
    clanTag: string;
    points: number;
}

interface ClanStandingsData {
    clanStandingsCurrentSeason: ClanLeaderboard[];
}

const clanComponentMap = {
    ASW: ASWScoreboardSVG,
    MFG: MFGScoreboardSVG,
    NSD: NSDScoreboardSVG,
    VHV: VHVScoreboardSVG,
};

function ClanStandingsPage() {
    const { data, loading, error } = useQuery<ClanStandingsData>(
        CLAN_STANDINGS_CURRENT_SEASON,
    );

    const clanData = data?.clanStandingsCurrentSeason || [];

    if (loading) {
        return <></>;
    }

    if (error) {
        return <></>;
    }

    return (
        <div className="">
            <div className="">
                {clanData.map((clan) => {
                    const ScoreboardComponent =
                        clanComponentMap[
                            clan.clanTag as keyof typeof clanComponentMap
                        ];

                    if (!ScoreboardComponent) {
                        console.warn(
                            `No component found for clan tag: ${clan.clanTag}`,
                        );
                        return null;
                    }

                    return (
                        <div key={clan.clanTag} className="">
                            <div className="w-full max-w-2xl">
                                <ScoreboardComponent
                                    seasonPoints={clan.points}
                                    clanName={clan.clanName}
                                    className="h-auto w-full"
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ClanStandingsPage;
